import React from 'react';
import { applyMiddleware, compose, createStore } from 'redux';
import ReactDOM from 'react-dom';
import Page from './components/Page';
import { Provider } from 'react-redux';
import step from './reducers';
import thunk from 'redux-thunk';
import * as API from '../api';
import { error } from 'plugins/toastr';
import { getIsDirty } from './reducers/dirty';
import $ from 'jquery';
import { withCurrentReferer } from 'plugins/contextual-back';

function dispatchErrors(store, error) {
  const errors = Object.keys(error)
    .map(key => {
      return key.substring(4);
    })
    .filter(e => e !== null);

  store.dispatch({
    type: 'errors',
    payload: errors,
  });
}

function handleError(sourceButton, err, store) {
  console.log('Error attempting to save case', err);
  sourceButton.removeAttribute('disabled');
  sourceButton.classList.remove('loading');
  if (err.res.status === 400) {
    // Handling errors properly
    err.res.json().then(json => dispatchErrors(store, json));
  } else {
    error('Une erreur est survenue pendant la sauvegarde du dossier');
  }
}

export default function bind() {
  const createLogger = require('redux-logger');
  const logger = createLogger({
    collapsed: true,
  });

  const middleware = [thunk, logger];
  const enhancers = [];

  const root = document.getElementById('creation-step-1');
  const id = root.getAttribute('data-id');
  const customerId = root.getAttribute('data-customer');
  const store = createStore(
    step,
    compose(applyMiddleware(...middleware), ...enhancers)
  );

  const dirtyHandler = () => {
    if (getIsDirty(store.getState())) {
      $('#creation-step-1 form').addClass('dirty');
    }
  };

  store.subscribe(dirtyHandler);

  ReactDOM.render(
    <Provider store={store}>
      <Page id={parseInt(id, 10)} customerId={parseInt(customerId, 10)} />
    </Provider>,
    root
  );

  const cleanDirty = () => $('#creation-step-1 form').removeClass('dirty');

  const createButton = document.getElementById('bt-create');
  if (createButton) {
    createButton.onclick = () => {
      cleanDirty();
      createButton.setAttribute('disabled', 'true');
      createButton.classList.add('loading');
      API.create(store.getState().form).then(
        res => window.location.replace(res.url),
        err => handleError(createButton, err, store)
      );
    };
  }

  const updateButton = document.getElementById('bt-save');
  if (updateButton) {
    const id = updateButton.getAttribute('data-id');
    const step = updateButton.getAttribute('data-step');
    updateButton.onclick = () => {
      cleanDirty();
      updateButton.setAttribute('disabled', 'true');
      updateButton.classList.add('loading');
      API.update(id, step, store.getState().form, false).then(
        res => window.location.replace(withCurrentReferer(res.url)),
        err => handleError(updateButton, err, store)
      );
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step1/index.js